import { render, staticRenderFns } from "./TagFireEditor.vue?vue&type=template&id=024746f5&scoped=true"
import script from "./TagFireEditor.vue?vue&type=script&lang=js"
export * from "./TagFireEditor.vue?vue&type=script&lang=js"
import style0 from "./TagFireEditor.vue?vue&type=style&index=0&id=024746f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024746f5",
  null
  
)

export default component.exports